import React, { forwardRef } from 'react'

import { IconProps } from './types'

const QrCode = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 5V2.5H5M2.5 11V13.5H5M11 13.5H13.5V11M13.5 5V2.5H11M9.5 10H11V11.5M9 11.5V10.5M9 8.5V9.5M5 5V7H7V5H5ZM11 5H9V7H11V5ZM5 9V11H7V9H5Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
QrCode.displayName = 'QrCode'

export default QrCode
